import { render, staticRenderFns } from "./TransactionsHeroCard.vue?vue&type=template&id=dd5d2ee8&scoped=true"
import script from "./TransactionsHeroCard.vue?vue&type=script&lang=js"
export * from "./TransactionsHeroCard.vue?vue&type=script&lang=js"
import style0 from "./TransactionsHeroCard.vue?vue&type=style&index=0&id=dd5d2ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5d2ee8",
  null
  
)

export default component.exports